import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort_title_active",
  "use": "sort_title_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"sort_title_active\"><g fill-rule=\"evenodd\"><path d=\"M3.75 11 3 13h6l-.75-2h-4.5Zm.375-1L6 5l1.875 5h-3.75ZM2 13 6 3l4 10H2Z\" /><path d=\"m10.232 16 5.334-8H10V7h6.493a.5.5 0 0 1 .015 0H17v.493a.5.5 0 0 1 0 .015V8h-.232l-5.334 8H17v1h-6.493a.5.5 0 0 1-.015 0H10v-.493a.5.5 0 0 1 0-.015V16h.232Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol